import { i18n } from './i18n';

/** Product/service drawer checks (document 06 S12), mirroring apps/api/src/items/dto.ts. */
export interface ItemCheck {
  kind: 'service' | 'non_inventory' | 'inventory';
  name: string;
  isSold: boolean;
  salesPrice: string;
  salesAccountId: string;
  isPurchased: boolean;
  purchasePrice: string;
  purchaseAccountId: string;
  hsnSac: string;
  uqc: string;
  inventoryAssetAccountId: string;
  initialQuantity: string;
  reorderPoint: string;
}

/** A default price in the home currency: up to 12 digits and 2 decimals, never negative. */
export const PRICE = /^\d{1,12}(\.\d{1,2})?$/;
/** A quantity: up to 12 digits and 6 decimals (numeric(18,6)). */
export const QTY = /^\d{1,12}(\.\d{1,6})?$/;

/** "1,250.00 " → "1250.00": the API strips thousands separators from prices and quantities. */
export const plainNumber = (v: string) => v.replace(/,/g, '').trim();

/** Field errors keyed like the API's validation paths; empty when the item can be saved. */
export function itemProblems(f: ItemCheck, india: boolean): Record<string, string> {
  const next: Record<string, string> = {};
  if (!f.name.trim()) next['name'] = i18n.t('accountDrawer.enterName');
  if (!f.isSold && !f.isPurchased) next['isSold'] = i18n.t('salesPages.itemChecks.soldOrPurchased');
  if (india && f.hsnSac && !/^([0-9]{4}|[0-9]{6}|[0-9]{8})$/.test(f.hsnSac))
    next['hsnSac'] = i18n.t('salesPages.itemChecks.hsnSac');
  if (india && f.uqc && !/^[A-Z]{3}$/.test(f.uqc))
    next['uqc'] = i18n.t('salesPages.itemChecks.uqc');
  if (f.isSold) {
    if (!f.salesAccountId) next['salesAccountId'] = i18n.t('salesPages.itemChecks.incomeAccount');
    if (plainNumber(f.salesPrice) && !PRICE.test(plainNumber(f.salesPrice)))
      next['salesPrice'] = i18n.t('salesPages.itemChecks.salesPrice');
  }
  if (f.isPurchased) {
    if (!f.purchaseAccountId)
      next['purchaseAccountId'] = i18n.t('salesPages.itemChecks.expenseAccount');
    if (plainNumber(f.purchasePrice) && !PRICE.test(plainNumber(f.purchasePrice)))
      next['purchasePrice'] = i18n.t('salesPages.itemChecks.purchasePrice');
  }
  if (f.kind === 'inventory') {
    if (!f.inventoryAssetAccountId)
      next['inventoryAssetAccountId'] = i18n.t('salesPages.itemChecks.inventoryAccount');
    if (plainNumber(f.initialQuantity) && !QTY.test(plainNumber(f.initialQuantity)))
      next['initialQuantity'] = i18n.t('salesPages.itemChecks.initialQuantity');
    if (f.reorderPoint.trim() && !QTY.test(f.reorderPoint.trim()))
      next['reorderPoint'] = i18n.t('salesPages.itemChecks.reorderPoint');
  }
  return next;
}
